<template>
  <v-container>
    <section>
      <br />
      <section id="firebaseui-auth-container"></section>
    </section>
  </v-container>
</template>

<script>
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import * as firebaseui from "firebaseui";
import "firebaseui/dist/firebaseui.css";

export default {
  data() {
    return {};
  },

  mounted() {
    let ui = firebaseui.auth.AuthUI.getInstance();
    if (!ui) {
      ui = new firebaseui.auth.AuthUI(firebase.auth());
    }

    var uiConfig = {
      // signInSuccessUrl: "/dashboard",
      signInOptions: [
        {
          provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
          recaptchaParameters: {
            type: "image", // 'audio'
            size: "normal", // 'invisible' or 'compact'
            badge: "bottomleft", //' bottomright' or 'inline' applies to invisible.
          },
          defaultCountry: "TH",
        },
        // {
        //   provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        //   // Required to enable ID token credentials for this provider.
        //   clientId: CLIENT_ID,
        // },
        // {
        //   provider: firebase.auth.FacebookAuthProvider.PROVIDER_ID,
        //   scopes: ["public_profile", "email", "user_likes", "user_friends"],
        // },
      ],
      callbacks: {
        signInSuccessWithAuthResult: function () {
          return false;
        },
      },
    };
    ui.start("#firebaseui-auth-container", uiConfig);
  },
};
</script>

<style>
</style>
